module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/awesome-typescript-loader/dist/entry.js!./transfer-subscription.ts"));
	}, "members-async-transfer-subscription");
}